<template>
  <div>
    <div>
      <div class="header">
        <img class="header-img" src="https://spkg.smartmice.cn/resources/images/official/common/areas041.jpg">
        <div class="title">
          <div>案例分享</div>
          <img src="https://spkg.smartmice.cn/resources/images/official/common/downBtn.png">
        </div>
      </div>
      <div class="content">
        <div class="txtContent">
          <div class="title">
            <div class="txt">
              <div class="zhTxt">{{detail.zhTitle}}</div>
              <div class="enTxt">{{detail.enTitle}}</div>
            </div>
            <img class="header-icon" src="https://spkg.smartmice.cn/resources/images/official/common/doubleLineLeft.png">
          </div>
          <ul v-if="detail.time || detail.place || detail.number || detail.des">
            <li v-if="detail.time">
              <img src="https://spkg.smartmice.cn/resources/images/official/common/address.png" class="smallIcon">
              <span>{{detail.time}} {{detail.place}}</span>
            </li>
            <li v-if="detail.number">
              <img src="https://spkg.smartmice.cn/resources/images/official/common/phone.jpg" class="smallIcon">
              <span>{{detail.number}}</span>
            </li>
            <li v-if="detail.des">
              <img src="https://spkg.smartmice.cn/resources/images/official/common/message.jpg" class="smallIcon">
              <span>{{detail.des}}</span>
            </li>
          </ul>
          <div>
            <div class="spot">项目亮点 :</div>
            <p style="line-height: 30px;" v-html="detail.spot"></p>
          </div>
        </div>
        <div class="imgContent">
          <div class="detailPicRow">
            <img class="detailPicBigImg" :src="(detailImg[activeId] || []).img">
            <div class="detailPicChangeBtnLeft" @click="change(false)">
              <img src="https://spkg.smartmice.cn/resources/images/official/common/arrowLeft.png">
            </div>
            <div class="detailPicChangeBtnRight" @click="change(true)">
              <img src="https://spkg.smartmice.cn/resources/images/official/common/arrowRight.png">
            </div>
          </div>
          <div class="detailPicChange">
            <div v-for="(item, index) in detailImg" :key="index">
              <img :class="{detailPicChangeOn: index == activeId}" :src="item.img">
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import Footer from "@/components/Footer";
export default {
  name: "ContactUs",
  components: {
    Footer
  },
  data() {
    return {
      store: this.$store.state,
      detail: {},
      detailImg: [],
      activeId: 0,
    };
  },
  methods: {
    change(params) {
      if(params) {
        this.activeId = this.activeId + 1
      } else {
        this.activeId = this.activeId - 1
      }
      if(this.activeId == -1) {
        this.activeId = 2
      }
      if(this.activeId == 3) {
        this.activeId = 0
      }
    }
  },
  mounted() {
    this.detail = this.store.service[this.$route.params.id];
    let that = this
    setInterval(function () {
      that.activeId = that.activeId + 1
      if(that.activeId == -1) {
        that.activeId = 2
      }
      if(that.activeId == 3) {
        that.activeId = 0
      }
    },5000)
    this.detailImg = [
      {img: this.detail.desImg1, active: true},
      {img: this.detail.desImg2, active: false},
      {img: this.detail.desImg3, active: false}
    ]
  }
};
</script>
<style lang="less" scoped>
@import '../../less/awardDetail.less';
</style>
